//
//
//
//

import FreelancersSearch from '@/components/client/FreelancersSearch'
import SeoMethods from '@/mixins/SeoMethods'
import Pageview from '@/mixins/Pageview'

export default {
  name: 'FreelancersListPage',
  components: { FreelancersSearch },
  mixins: [SeoMethods, Pageview],
  auth: false,
  head () {
    return this.buildTags(
      this.$t('meta.freelancersTitle'),
      this.$t('meta.freelancersDescription'),
      null,
      this.$t('meta.freelancersKeywords')
    )
  }
}
